import { useContext, useState } from "react";
import { Button, Dialog, PickList } from "iuvity-ui-components";
import { AppContext } from "../../context/index";
import { NewDialogProps } from "../dialog/NewCustomDialog";

interface PickListProps {
  sourceData: any;
  targetData: any;
  visible: boolean;
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  actionFn: Function;
  reloadFn: Function;
  limit: number;
  context?: string;
  auxModalController: React.Dispatch<React.SetStateAction<NewDialogProps>>;
}

export const PickListModal: React.FC<PickListProps> = ({
  sourceData,
  targetData,
  visible,
  setVisible,
  context,
  actionFn,
  reloadFn,
  limit,
  auxModalController
}) => {
  const {
    t,
    appState: { user, selectedProduct, selectedTransaction },
  } = useContext(AppContext);
  const [changeFields, setChangeFields] =  useState(false);
  const [target, setTarget] = useState(targetData);
  const [source, setSource] = useState(sourceData);
  const [initialValue, setInitialValue] = useState(target);

  const type = context
    ? {
      key: "productid",
      elem: selectedProduct,
      extraInfo: { usagetype: context },
    }
    : {
      key: "transactionid",
      elem: selectedTransaction,
      extraInfo: {},
    };

  const onMoveToSource = (e: any) => {
    if (!source.find((elem: any) => elem.label === e.value[0].label)) {
      setTarget([...target.filter((field: any) => field.id !== e.value[0].id)]);
      setSource(
        [...source, ...e.value].sort((a, b) => a.label.localeCompare(b.label))
      );
    }
  };

  const onMoveToTarget = (e: any) => {
    if (limit > 0 && target.length >= limit) return;
    setSource(
      [...source.filter((field: any) => field.id !== e.value[0].id)].sort(
        (a, b) => a.label.localeCompare(b.label)
      )
    );
    setTarget([...target, ...e.value]);
  };
  const onChange = (e: any) => {
    setChangeFields(true);
    setTarget(e.target);
  }

  const onMoveAllToSource = (e: any) => {
    setTarget([]);
    setSource(
      [...source, ...e.value].sort((a, b) => a.label.localeCompare(b.label))
    );
  };

  const onMoveAllToTarget = (e: any) => {
    if (limit > 0 && target.length + e.value.length > limit) return;
    setSource([]);
    setTarget([...target, ...e.value]);
  };

  const onSave = async () => {
    setVisible(false);
    const newFieldsData =
      target.length > 0
        ? target.map((field: any, idx: number) => ({
          mappedfieldid: field.id,
          [type.key]: type.elem?.id,
          fieldorder: idx + 1,
          createdby: user?.name,
          status: "ACTIVE",
          ...type.extraInfo,
        }))
        : [{ [type.key]: type.elem?.id, ...type.extraInfo }];

    const updateStatus = await actionFn("FIELD", "UPDATE", newFieldsData);
    if (updateStatus === "ERROR") {
      setVisible(true);
    } else {
      setInitialValue(target);
      reloadFn();
    }
  };

  const onConfirmSave = () => {
    setVisible(false);
    auxModalController((prev) => ({
      ...prev,
      visible: true,
      title: t("Products.saveModalTitle"),
      content: t("Products.saveModalContent"),
      onConfirm: onSave,
    }));
  };

  const onCancel = () => {
    setChangeFields(false)
    setVisible(false)
    setTarget(targetData)
    setSource(sourceData)
  }
  return (
    <Dialog
      className="overflow-hidden"
      header={t("Products.moreInfoLabel")}
      onHide={onCancel}
      visible={visible}
      footer={false}
    >
      <PickList
        dataKey="id"
        id="pick-list"
        className="ap-selector-c my-5"
        showSourceControls={false}
        showTargetControls={true}
        sourceHeader={t("Products.availableFieldsLabel")}
        targetHeader={t("Products.selectedFieldsLabel")}
        source={source}
        target={target}
        onMoveAllToSource={onMoveAllToSource}
        onMoveAllToTarget={onMoveAllToTarget}
        onMoveToSource={onMoveToSource}
        onMoveToTarget={onMoveToTarget}
        onChange={onChange}
      />
      <div className="ap-selector-btn-c gap-4 mb-5">
        <Button
          variant="p-button-link"
          label={t("Products.cancelBtnLabel")}
          onClick={onCancel}
        />
        <Button
          variant="p-button"
          label={t("Products.saveBtnLabel")}
          onClick={onConfirmSave}
          disabled={`${target}` === `${initialValue}` && !changeFields}
        />
      </div>
    </Dialog>
  );
};
